// The addresses of «زنجیره تأمین», on their own so the sidebar names them without loading the module's pages.

export const SUPPLY_CHAIN_FEATURE = 'supplyChain'

export const SUPPLY_CHAIN_OVERVIEW = '/supply-chain/overview'

/** The business's own pages: the overview and its requests. */
export const SUPPLY_CHAIN_BUSINESS_PATHS = ['/supply-chain/overview', '/supply-chain/requests']

export const SUPPLY_CHAIN_STAFF_ROOT = '/supply-chain/admin'

/** The CRM a case opens in. */
export const SUPPLY_CHAIN_CRM_URL = 'https://crm.asatsp.ir'

/** The staff area's pages, in its tabs and the sidebar's «زنجیره تأمین (آسا)». */
export const SUPPLY_CHAIN_STAFF_PAGES: Array<{to: string; title: string; icon: string}> = [
  {to: '/supply-chain/admin/cases', title: 'کارتابل پرونده‌ها', icon: 'la-folder-open'},
  {to: '/supply-chain/admin/requests', title: 'درخواست‌های پنل', icon: 'la-inbox'},
  {to: '/supply-chain/admin/lists', title: 'لیست‌های توانیر', icon: 'la-paper-plane'},
  {to: '/supply-chain/admin/links', title: 'ثبت زنجیره‌ها', icon: 'la-link'},
  {to: '/supply-chain/admin/waiting', title: 'خریداران منتظر فهرست', icon: 'la-user-clock'},
  {to: '/supply-chain/admin/parties', title: 'فهرست‌های مرجع', icon: 'la-list-alt'},
  {to: '/supply-chain/admin/customers', title: 'مشتریان زنجیره', icon: 'la-building'},
]
